import { Drawer } from "antd"

interface ExpandDrawerRow {
  label: string
  value: React.ReactNode
}

interface ExpandDrawerProps {
  open: boolean
  onClose: () => void
  title: string
  rows: ExpandDrawerRow[]
}

export const ExpandDrawer = ({
  open,
  onClose,
  title,
  rows,
}: ExpandDrawerProps) => {
  return (
    <Drawer
      title={title}
      placement="right"
      width={500}
      onClose={onClose}
      open={open}
      closable={true}
      className="[&_.ant-drawer-header]:border-b [&_.ant-drawer-header]:border-[#E2E8F0] [&_.ant-drawer-title]:text-[#62748E] [&_.ant-drawer-title]:text-sm [&_.ant-drawer-title]:font-medium [&_.ant-drawer-body]:p-0"
    >
      <div className="flex flex-col text-sm">
        {rows.map((row, i) => (
          <div
            key={i}
            className="grid grid-cols-[180px_1fr] border-b border-[#E2E8F0]"
            style={{ minHeight: "44px" }}
          >
            <div className="bg-[#F8FAFC] px-4 flex items-center font-medium">
              <span className="text-sm text-[#62748E]">{row.label}</span>
            </div>
            <div className="px-4 flex items-center">
              <span className="text-sm text-[#020618]">{row.value}</span>
            </div>
          </div>
        ))}
      </div>
    </Drawer>
  )
}
